export default __webpack_public_path__ + "static/media/SeminarioIes2026_GabrielaPermeo.b28f3d84.jpg";